module.exports = __webpack_public_path__ + "static/media/shane.c7cdc1c9.jpg";